import { z } from "zod";

import { RELATIONS, RESOURCE_TYPES, SUBJECT_TYPES } from "../../../../shared/domain/permissions";

export const ResolvedUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().email(),
  avatarUrl: z.string().url().nullable()
});

export const ResolvedGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  memberCount: z.number().int().nonnegative()
});

/**
 * Full permission record as returned by list/access endpoints.
 * Subject info is resolved server-side for UI rendering.
 */
export const PermissionRecordSchema = z.object({
  id: z.string().uuid(),
  resourceType: z.enum(RESOURCE_TYPES),
  resourceId: z.string(),
  subjectType: z.enum(SUBJECT_TYPES),
  subjectId: z.string(),
  relation: z.enum(RELATIONS),
  grantedByUserId: z.string().nullable(),
  createdAt: z.string().datetime(),
  user: ResolvedUserSchema.nullable(),
  group: ResolvedGroupSchema.nullable()
});

export type PermissionRecord = z.infer<typeof PermissionRecordSchema>;
export type ResolvedUser = z.infer<typeof ResolvedUserSchema>;
export type ResolvedGroup = z.infer<typeof ResolvedGroupSchema>;
